export const GET_DASHBOARDVALUEOVERTIME_ABORTED =
  'GET_DASHBOARDVALUEOVERTIME_ABORTED';
export const GET_DASHBOARDVALUEOVERTIME_REQUESTED =
  'GET_DASHBOARDVALUEOVERTIME_REQUESTED';
export const GET_DASHBOARDVALUEOVERTIME_COMPLETED =
  'GET_DASHBOARDVALUEOVERTIME_COMPLETED';
export const GET_DASHBOARDVALUEOVERTIME_FAILED =
  'GET_DASHBOARDVALUEOVERTIME_FAILED';
export const RESET_DASHBOARDVALUEOVERTIME_REQUESTED =
  'RESET_DASHBOARDVALUEOVERTIME_REQUESTED';
export const RESET_DASHBOARDVALUEOVERTIME_COMPLETED =
  'RESET_DASHBOARDVALUEOVERTIME_COMPLETED';
